import { createFileRoute } from '@tanstack/react-router';

import { QcChecklistsPage, qcTemplatesQueryOptions } from '@/features/workflows';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/qc-checklists/')({
  staticData: { tours: ['qc.list'] },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...qcTemplatesQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: QcChecklistsPage,
});
